package com.gsb.vyapar.bhagya.presentation.admin.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.User
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getFirstName
import com.gsb.vyapar.bhagya.domain.getGotra
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.domain.getImage
import com.gsb.vyapar.bhagya.domain.getKuldev
import com.gsb.vyapar.bhagya.domain.getLastName
import com.gsb.vyapar.bhagya.domain.getMobile
import com.gsb.vyapar.bhagya.domain.getPassword
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.resizeImage
import com.gsb.vyapar.bhagya.interactor.util.showError
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.presentation.auth.util.getOtherUser
import com.gsb.vyapar.bhagya.presentation.auth.util.saveUserUI
import com.gsb.vyapar.bhagya.presentation.auth.util.saveUserUIAdmin
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.EmailEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.FirstNameEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.GotraEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.KuldevEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.LastNameEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.MobileNumberEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.MobileUserIdEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.UserIdEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.UserIdPasswordEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.toolbar.Toolbar
import com.gsb.vyapar.bhagya.util.BLANK_PROFILE
import com.gsb.vyapar.bhagya.util.isValidMobileNumber
import com.gsb.vyapar.bhagya.util.orEmpty
import com.gsb.vyapar.bhagya.util.toU
import com.gsb.vyapar.bhagya.util.value
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import kotlinx.coroutines.launch

@Composable
fun GetUserView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    var user: User? by remember { mutableStateOf(null) }
    var userIdOrMobile by remember { mutableStateOf("") }
    var mobile by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    var image by remember { mutableStateOf("") }
    var firstName by remember { mutableStateOf("") }
    var lastName by remember { mutableStateOf("") }
    var gotra by remember { mutableStateOf("") }
    var kuldev by remember { mutableStateOf("") }
    var userId by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var imageFile: Pair<ByteArray, String>? by remember { mutableStateOf(null) }
    val coroutineScope = rememberCoroutineScope()
    val imagePickerLauncher = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        if (selectedImage != null) coroutineScope.launch {
            imageFile = Pair(resizeImage(selectedImage.readBytes().orEmpty()), selectedImage.name)
        }
        hideLoading()
    }
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            Toolbar("Get User")
            Column(Modifier.verticalScroll(rememberScrollState()).padding(horizontal = 16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
                Spacer(Modifier.height(15.dp))
                MobileUserIdEditText(userIdOrMobile) { userIdOrMobile = it }
                Spacer(Modifier.height(16.dp))
                GVBButton(text = "Get User") {
                    showLoading()
                   getOtherUser(if (isValidMobileNumber(userIdOrMobile)) userIdOrMobile.toU() else userIdOrMobile) {
                       hideLoading()
                       user = it
                       if (it != null) {
                           mobile = it.getMobile()
                           email = it.getEmail()
                           image = it.getImage()
                           firstName = it.getFirstName()
                           lastName = it.getLastName()
                           gotra = it.getGotra()
                           kuldev = it.getKuldev()
                           userId = it.getId()
                           password = it.getPassword()
                       } else {
                           showError("Not able to get user")
                       }
                   }
                }
                user?.let {
                    Spacer(Modifier.height(15.dp))
                    uiState.getImage(image.ifEmpty { BLANK_PROFILE.value() })?.let { imageBitmap ->
                        CommonImage(imageBitmap, 150.dp, 150.dp, Modifier.clickable {
                            imagePickerLauncher.launch()
                            showLoading()
                        })
                    }?: PlaceHolder(150.dp, 150.dp, Modifier.clickable {
                        imagePickerLauncher.launch()
                        showLoading()
                    })
                    Spacer(Modifier.height(15.dp))
                    FirstNameEditText(firstName) { firstName = it }
                    Spacer(Modifier.height(8.dp))
                    LastNameEditText(lastName) { lastName = it }
                    Spacer(Modifier.height(8.dp))
                    MobileNumberEditText(mobile, false) {  }
                    Spacer(Modifier.height(8.dp))
                    EmailEditText(email, false) {  }
                    Spacer(Modifier.height(8.dp))
                    GotraEditText(gotra) { gotra = it }
                    Spacer(Modifier.height(8.dp))
                    KuldevEditText(kuldev) { kuldev = it }
                    Spacer(Modifier.height(8.dp))
                    UserIdEditText(userId) {  }
                    Spacer(Modifier.height(8.dp))
                    UserIdPasswordEditText(password) { password = it }
                    Spacer(Modifier.height(16.dp))
                    GVBButton(text = "Save") {
                        saveUserUIAdmin(user!!, mobile, email, image, firstName, lastName, gotra, kuldev, password)
                    }
                    Spacer(Modifier.height(16.dp))
                }
            }
        }
    }
}